import React from 'react';
import { Link } from 'react-router-dom';

class NotFoundPage extends React.Component{
    render(){
        return <div style={{display:'grid', placeContent:'center', textAlign:'center', padding:'40px 20px', color:'#152033', background:'#f5f7f9', minHeight:'100vh'}}>
          <p style={{color:'#0d969d', fontWeight:800, letterSpacing:'.14em'}}>404 · ATLAS SPORT</p>
          <h1 style={{fontSize:'clamp(42px, 7vw, 72px)', margin:'5px 0 12px'}}>Looks like you are off track.</h1>
            <p>
              <Link to="/"><button type="button" style={{padding:'14px 20px', border:0, borderRadius:'10px', color:'#07191b', background:'#16c5c7', fontWeight:800, cursor:'pointer'}}>Back to Atlas Sport</button></Link>
            </p>
          </div>;
    }
}
export default NotFoundPage;
